import { Fragment, createElement } from 'react'
import PropTypes from 'prop-types'
import startCase from 'lodash/startCase'

import * as SVG from './icons'

function Icon ({ name, fill = 'currentColor', ...props }) {
  const normalizeName = startCase(name).replace(' ', '')

  return (
    <Fragment>
      {fill === 'linear' && <SVG.LinearGradient />}
      {createElement(SVG[normalizeName], {
        fill,
        hasLinear: fill === 'linear',
        ...props
      })}
    </Fragment>
  )
}

Icon.propTypes = {
  name: PropTypes.oneOf([
    'bricks',
    'cart',
    'calendar',
    'calendarg',
    'cart_special',
    'course',
    'content',
    'checked',
    'clock',
    'coupon',
    'close',
    'close_tiny',
    'coupon_money',
    'dollar_note',
    'dollar_sign',
    'fence',
    'gift',
    'giftg',
    'grill',
    'percent',
    'received',
    'share',
    'user',
    'liked',
    'settings',
    'stars',
    'trophy',
    'warning'
  ]).isRequired,
  fill: PropTypes.string
}

export default Icon
